// 检测是否在微信浏览器中打开
export function isWechatBrowser() {
  const ua = navigator.userAgent.toLowerCase()
  return ua.indexOf('micromessenger') !== -1
}

// 检测是否在移动设备上
export function isMobileDevice() {
  return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)
}

export const COMPACT_BREAKPOINT = 768

/** 窄屏或移动设备：使用精简顶栏 */
export function isCompactViewport() {
  if (typeof window === 'undefined') return isMobileDevice()
  return isMobileDevice() || window.innerWidth < COMPACT_BREAKPOINT
}

export const WX_LOGIN_MANUAL_KEY = 'wx_login_manual' 